module.exports = "<div class=\"app header-fixed sidebar-fixed aside-menu-fixed aside-menu-hidden\">\n  <app-header></app-header>\n  <div class=\"app-body\">\n    <app-sidebar [navigation]=\"nav\"></app-sidebar>\n    <!-- Main content -->\n    <main class=\"main\">\n      <router-outlet></router-outlet>\n    </main>\n  </div>\n  <app-footer></app-footer>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/dfm/cryosoft/ui/src/app/layouts/members-layout/members-layout.component.html
// module id = ../../../../../src/app/layouts/members-layout/members-layout.component.html
// module chunks = main